const zh = {
	nav: {
		home: '首页',
		california: '加州',
		texas: '德州',
		florida: '佛州',
		menu: '菜单',
		faq: '常见问题',
		freeEstimate: '免费报价',
		bookNow: '立即预约',
		myBooking: '查询预约',
	},
	seo: {
		homeDescription: '全美顶级上门铁板烧体验。我们将铁板烧设备和专业厨师送到您的家中，服务加州、德州和佛州。',
	},
	hero: {
		title: 'HAPPY HIBACHI',
		tagline: '全美#1上门铁板烧',
		subtitle: '在您家中体验正宗的日式铁板烧烹饪',
		description:
			'专业厨师将铁板烧烹饪的精彩直接带到您的后院，为您的家人和宾客创造难忘的用餐体验。',
		bookNow: '立即预约',
		freeEstimate: '免费报价',
	},
	howItWorks: {
		title: '服务流程',
		subtitle: '简单几步，打造完美铁板烧派对',
		step1: {
			title: '在线预约',
			description: '选择您的日期、时间和菜单偏好',
		},
		step2: {
			title: '我们准备',
			description: '我们的团队准备所有食材和设备',
		},
		step3: {
			title: '享受表演',
			description: '观看厨师表演，享用美味佳肴',
		},
		step4: {
			title: '我们清理',
			description: '放松休息，我们负责所有清理工作',
		},
	},
	menu: {
		title: '价格与服务',
		subtitle: '新鲜食材，正宗风味',
		proteins: '主菜',
		sides: '配菜和开胃菜',
		chicken: '鸡肉',
		steak: '菲力牛排',
		shrimp: '虾',
		salmon: '三文鱼',
		lobster: '龙虾尾',
		tofu: '豆腐（素食）',
		friedRice: '铁板炒饭',
		noodles: '日式炒面',
		vegetables: '烤蔬菜',
		salad: '姜汁沙拉',
		soup: '味噌汤',
		edamame: '毛豆',
		includes: {
			salad: '新鲜沙拉',
			rice: '铁板炒饭',
			vegetables: '铁板烧蔬菜',
			show: '表演与游戏',
		},
		protein: {
			title: '蛋白质选择',
			included: '已包含',
		},
		upgrades: {
			title: '高级升级',
			filet: '菲力牛排',
			lobster: '龙虾',
			ribeye: '顶级肋眼牛排',
			shrimp: '大虾',
			salmon: '野生三文鱼',
			scallops: '大扇贝',
		},
		addons: {
			title: '加菜',
			gyoza: '煎饺 (12个)',
			edamame: '毛豆',
			noodles: '面条',
			thirdProtein: '第三份蛋白质',
		},
		coupon: {
			title: '特别优惠券',
			subtitle: '仅限周日至周五派对！',
			email: '请发邮件至',
		},
		note: {
			outdoor: '我们仅在户外烹饪。',
			weather: '无论晴雨，只要有干燥的烹饪区域，我们都会提供服务。',
		},
	},
	pricing: {
		title: '价格',
		subtitle: '透明定价，无隐藏费用',
		perPerson: '每人',
		minimum: '所有派对最低消费',
		kids: '12岁及以下儿童价格',
		includes: '包含',
		includesList: {
			chef: '专业铁板烧厨师',
			ingredients: '所有食材和用品',
			equipment: '铁板烧烤架和设备',
			setup: '布置和清理',
			show: '现场烹饪表演',
		},
		basic: {
			title: '基础套餐',
			description: '适合小型聚会',
		},
		premium: {
			title: '高级套餐',
			description: '完整铁板烧体验',
		},
		deluxe: {
			title: '豪华套餐',
			description: '极致奢华用餐',
		},
	},
	calendar: {
		available: '可预约',
		limited: '少量',
		busy: '紧张',
		unavailable: '不可用',
		today: '今天',
		prevMonth: '上个月',
		nextMonth: '下个月',
		weekdays: {
			sun: '日',
			mon: '一',
			tue: '二',
			wed: '三',
			thu: '四',
			fri: '五',
			sat: '六',
		},
		months: {
			january: '一月',
			february: '二月',
			march: '三月',
			april: '四月',
			may: '五月',
			june: '六月',
			july: '七月',
			august: '八月',
			september: '九月',
			october: '十月',
			november: '十一月',
			december: '十二月',
		},
	},
	slider: {
		chef: '专业铁板烧厨师表演',
		steak: '美味铁板烧牛排',
		shrimp: '鲜美铁板烧虾',
		setup: '高级铁板烧设备',
		presentation: '精美食物摆盘',
	},
	booking: {
		title: '预约体验',
		subtitle: '选择您的地区开始预约',
		selectRegion: '选择您的地区',
		california: '加利福尼亚',
		texas: '德克萨斯',
		florida: '佛罗里达',
		californiaTagline: '专业铁板烧送到您家门',
		texasTagline: '将铁板烧精品带到德州',
		floridaTagline: '阳光之州的铁板烧体验',
		servingAreas: '服务区域',
		bookIn: '立即预约',
		note: '* 现在无需付款，我们会联系您确认预约。',
		quickBook: '快速预约：',
		summary: '预约详情',
		addToCalendar: '添加到日历',
	},
	calculator: {
		title: '价格计算器',
		subtitle: '即时获取活动预估价格',
		guests: '客人数量',
		adults: '成人',
		kids: '儿童（10岁及以下）',
		upgrades: '可选升级',
		summary: '价格明细',
		subtotal: '小计',
		discount: '团体折扣',
		minimum: '最低消费',
		total: '合计',
		gratuity: '建议小费',
		grandTotal: '总计',
		bookNow: '预约活动',
		note: '* 根据位置可能收取交通费。最终价格在预约时确认。',
		minimumNotice: '最少10位客人',
		thirdProtein: '第三份蛋白质',
		noodles: '面条',
	},
	gallery: {
		title: '相册',
		subtitle: '体验 Happy Hibachi 的独特魅力',
		items: {
			chef: '专业铁板烧厨师',
			chefDesc: '专业铁板烧厨师现场表演',
			grill: '铁板烧设备',
			grillDesc: '高级铁板烧设备',
			steak: '铁板烧牛排',
			steakDesc: '美味铁板烧牛排',
			vegetables: '铁板烧蔬菜',
			vegetablesDesc: '新鲜铁板烧蔬菜',
			shrimp: '铁板烧虾',
			shrimpDesc: '鲜美铁板烧虾',
			food: '美食摆盘',
			foodDesc: '精美食物摆盘',
		},
	},
	reviews: {
		title: '客户评价',
		subtitle: '看看客户们对 Happy Hibachi 体验的评价',
		bookNow: '预约活动',
		ctaTitle: '准备好创造您的精彩体验了吗？',
		ctaText: '加入数百位满意客户的行列',
		rating: '5.0 平均评分',
		verified: '100+ 真实评价',
		topRated: '顶级评价服务',
	},
	instagram: {
		title: '关注我们的动态',
		followUs: '关注我们的 INSTAGRAM',
	},
	referral: {
		title: '推荐朋友，赢取奖励',
		subtitle: '分享铁板烧的快乐，获得奖励！',
		step1Title: '分享您的推荐码',
		step1Desc: '与朋友和家人分享您的专属推荐码',
		step2Title: '朋友预约',
		step2Desc: '您的朋友首次预约可享受$30优惠',
		step3Title: '您获得奖励',
		step3Desc: '获得$50积分用于下次活动',
		yourReward: '您的奖励',
		friendDiscount: '朋友的折扣',
		getCode: '获取推荐码',
		emailPlaceholder: '输入您的邮箱',
		invalidEmail: '请输入有效的邮箱地址',
		getCodeBtn: '获取推荐码',
		successTitle: '您的推荐码已准备好！',
		successDesc: '请查看邮箱获取您的专属推荐码和说明。',
		terms: '* 奖励在朋友完成首次预约后生效。推荐次数无上限！',
	},
	newsletter: {
		title: '获取专属优惠',
		subtitle: '订阅我们的通讯，获取特惠和派对技巧！',
		placeholder: '输入您的邮箱地址',
		subscribe: '订阅',
		invalidEmail: '请输入有效的邮箱地址',
		success: '感谢订阅！请查看邮箱获取专属优惠。',
		error: '出现问题，请重试。',
		privacy: '我们尊重您的隐私。随时可退订。',
		benefit1: '专属折扣',
		benefit2: '派对策划技巧',
		benefit3: '新菜单更新',
	},
	myBooking: {
		title: '查询我的预约',
		subtitle: '输入您预约时使用的邮箱或手机号',
		emailPlaceholder: '请输入邮箱地址',
		phonePlaceholder: '请输入手机号码',
		search: '查询预约',
		searching: '查询中...',
		results: '查询结果',
		noResults: '未找到预约记录',
		error: '查询失败，请重试',
		bookingId: '预约号',
		needHelp: '需要帮助？',
		contactUs: '如有任何问题，请随时联系我们',
		pendingNote: '我们将在2小时内联系您确认预约',
		confirmedNote: '期待您的到来！厨师将提前30分钟到达',
	},
	faq: {
		title: '常见问题',
		subtitle: '您需要了解的一切',
		q1: '你们服务哪些地区？',
		a1: '我们目前服务加利福尼亚、德克萨斯和佛罗里达。请联系我们确认是否覆盖您的具体位置。',
		q2: '可以容纳多少位客人？',
		a2: '我们要求最少10位客人，最多可容纳50位。如需更大规模的活动，请联系我们进行特殊安排。',
		q3: '我需要提供什么？',
		a3: '您只需提供场地和您的客人！我们带来所有设备、食材、餐具，并负责所有布置和清理工作。',
		q4: '需要提前多久预约？',
		a4: '我们建议工作日活动至少提前2周预约，周末活动提前3-4周。热门日期很快就会被预订！',
		q5: '你们能满足特殊饮食要求吗？',
		a5: '可以！我们提供素食选项，可以满足大多数饮食限制。请在预约时告知我们。',
		q6: '你们的取消政策是什么？',
		a6: '活动前7天以上取消可全额退款。提前3-6天通知退还50%。提前不足3天通知不予退款。',
	},
	contact: {
		title: '联系我们',
		subtitle: '我们随时为您服务',
		phone: '电话',
		email: '邮箱',
		hours: '营业时间',
		address: '服务区域',
	},
	footer: {
		description: '将正宗铁板烧体验带到您家',
		quickLinks: '快速链接',
		contact: '联系方式',
		followUs: '关注我们',
		copyright: '© 2024 Happy Hibachi. 版权所有。',
		allRightsReserved: '版权所有',
		privacyPolicy: '隐私政策',
		termsOfService: '服务条款',
	},
	menuSelection: {
		title: '选择您的菜品类型',
		subtitle: '所有套餐包含米饭、铁板烧蔬菜和特制酱料',
		regular: {
			title: '标准套餐',
			proteins: '每人2份蛋白质',
			service: '含表演，90分钟服务',
		},
		premium: {
			title: '高级套餐',
			proteins: '2份高级蛋白质：菲力牛排、龙虾、扇贝',
			service: '含表演，120分钟服务',
		},
		catering: {
			title: '大型聚会',
			note: '50人以上自助餐形式',
			proteins: '每人2份蛋白质',
			service: '含表演，3-4小时服务',
		},
		intimate: {
			title: '小型派对',
			note: '5-7位客人',
			includes: '沙拉、饺子、毛豆、面条 + 混合蛋白质',
			substitution: '同价位蛋白质可替换',
		},
	},
	form: {
		name: '姓名',
		namePlaceholder: '请输入您的姓名',
		email: '邮箱地址',
		emailPlaceholder: '请输入邮箱',
		phone: '电话号码',
		phonePlaceholder: '请输入电话号码',
		date: '活动日期',
		time: '首选时间',
		guests: '客人数量',
		guestsHint: '最少10位客人',
		region: '选择地区',
		eventType: '活动类型',
		message: '附加信息',
		messagePlaceholder: '告诉我们您的活动详情...',
		submit: '提交',
		submitting: '提交中...',
		submitReservation: '提交预约',
		success: '预约提交成功！',
		successMessage: '我们的团队将在2小时内与您联系确认活动详情。',
		weWillContact: '我们会尽快与您联系确认详情。',
		error: '出现问题，请重试或直接致电我们。',
		required: '必填',
		selectOption: '请选择',
		selectDate: '选择日期',
		people: '人',
		noPaymentRequired: '* 现在无需付款，我们会联系您确认预约。',
		invalidEmail: '请输入有效的邮箱地址',
		invalidPhone: '请输入有效的电话号码',
		eventTypes: {
			birthday: '生日派对',
			anniversary: '周年纪念',
			graduation: '毕业典礼',
			corporate: '企业活动',
			holiday: '节日派对',
			other: '其他',
		},
		referralSource: '您是如何知道我们的？',
		referral: {
			google: 'Google 搜索',
			friend: '朋友推荐',
			event: '在活动中见过',
			other: '其他',
		},
		couponCode: '优惠码',
		couponPlaceholder: '输入优惠码（可选）',
		applyCoupon: '验证',
	},
	estimate: {
		title: '获取免费报价',
		subtitle: '告诉我们您的活动详情，我们将为您提供定制报价',
		benefits: {
			title: '为什么选择我们？',
			professional: '专业训练有素的厨师',
			fresh: '新鲜优质的食材',
			entertainment: '现场烹饪表演',
			cleanup: '完整的布置和清理服务',
			custom: '可定制的菜单选项',
		},
	},
	bookNow: {
		title: '预约您的铁板烧派对',
		subtitle: '填写下方表格预订您的日期',
		selectRegion: '首先，选择您的地区',
		formTitle: '活动详情',
		pricing: '价格从$45/人起',
		note: '我们将在2小时内确认可用性',
	},
	notFound: {
		title: '页面未找到',
		description: '您访问的页面不存在。',
		backHome: '返回首页',
	},
	common: {
		learnMore: '了解更多',
		viewAll: '查看全部',
		loading: '加载中...',
		close: '关闭',
		backToHome: '返回首页',
		total: '总计',
		toBeConfirmed: '待确认',
		specialOffer: '特别优惠',
		goTo: '跳转到',
		previous: '上一个',
		next: '下一个',
	},
	topBar: {
		textUs: '发短信',
		email: '邮件',
	},
	photoShare: {
		title: '分享您的照片',
		subtitle: '分享您的铁板烧体验，下次活动立享$25优惠！',
		option1Title: '发布到 Instagram',
		option1Desc: '标记我们并使用 #HappyHibachi',
		option2Title: '直接上传',
		option2Desc: '与我们分享您的照片',
		dropzone: '拖放照片到此处或点击浏览',
		maxFiles: '最多5张照片',
		instagramPlaceholder: '您的 Instagram 用户名（可选）',
		submit: '提交照片',
		submitting: '上传中...',
		successTitle: '照片已提交！',
		successDesc: '感谢分享！$25优惠将在您下次预订时使用。',
		terms: '* 照片审核通过后生效。照片可能会在我们的社交媒体上展示。',
	},
	offer: {
		noTravel: '免交通费',
		within50: '50英里内',
		noHidden: '无隐藏费用',
		exclusive: '专属折扣',
		freeSetup: '免费桌椅',
		sunFri: '周日至周五特惠！',
	},
	coupon: {
		minGuests: '至少需要 {{count}} 位客人',
		applied: '优惠码有效！折扣: {{discount}}',
		invalid: '优惠码无效',
		checkFailed: '验证失败',
		under15: '15人以下',
		range15to25: '15-25人',
		range25to35: '25-35人',
		over35: '35人以上',
	},
	privacy: {
		title: '隐私政策',
		lastUpdated: '最后更新: 2026年1月',
		section1: {
			title: '1. 我们收集的信息',
			intro: '当您使用 Happy Hibachi 服务时，我们可能会收集：',
			contact: '联系信息',
			contactDesc: '姓名、电子邮件地址、电话号码',
			booking: '预约详情',
			bookingDesc: '活动日期、时间、地点、客人数量',
			payment: '付款信息',
			paymentDesc: '通过第三方支付服务商安全处理',
			usage: '使用数据',
			usageDesc: '您与我们网站的互动方式',
		},
		section2: {
			title: '2. 我们如何使用您的信息',
			item1: '处理和确认您的预约',
			item2: '发送预约确认和提醒',
			item3: '回复您的咨询',
			item4: '改进我们的服务',
			item5: '发送促销优惠（经您同意）',
		},
		section3: {
			title: '3. 信息共享',
			intro: '我们不会出售您的个人信息。我们可能会与以下方共享信息：',
			item1: '协助我们运营的服务提供商',
			item2: '法律要求时的执法机构',
		},
		section4: {
			title: '4. 数据安全',
			desc: '我们采取适当的安全措施保护您的个人信息。但是，互联网传输无法保证100%安全。',
		},
		section5: {
			title: '5. 您的权利',
			intro: '您有权：',
			item1: '访问您的个人数据',
			item2: '要求更正不准确的数据',
			item3: '要求删除您的数据',
			item4: '退出营销通讯',
		},
		section6: {
			title: '6. Cookies',
			desc: '我们使用 Cookies 来改善您的浏览体验并分析网站流量。您可以通过浏览器设置控制 Cookies。',
		},
		section7: {
			title: '7. 联系我们',
			intro: '如有隐私相关问题：',
		},
	},
	terms: {
		title: '服务条款',
		lastUpdated: '最后更新: 2026年1月',
		section1: {
			title: '1. 服务内容',
			desc: 'Happy Hibachi 提供上门铁板烧餐饮服务。我们将专业厨师和设备带到您的场地，为您准备正宗的铁板烧美食。',
		},
		section2: {
			title: '2. 预约与预订',
			minimum: '最低人数',
			minimumDesc: '最少需要10位客人',
			confirmation: '确认',
			confirmationDesc: '预约将在我们团队联系您后确认',
			deposit: '押金',
			depositDesc: '可能需要支付押金以确保您的日期',
			finalCount: '最终人数',
			finalCountDesc: '客人数量需在活动前48小时确认',
		},
		section3: {
			title: '3. 取消政策',
			sevenDays: '提前7天以上',
			sevenDaysDesc: '全额退还押金',
			threeSixDays: '提前3-6天',
			threeSixDaysDesc: '退还50%押金',
			lessThanThree: '少于3天',
			lessThanThreeDesc: '押金不予退还',
			weather: '天气原因',
			weatherDesc: '恶劣天气将免费改期',
		},
		section4: {
			title: '4. 客户责任',
			intro: '客户需提供：',
			item1: '足够的户外烹饪空间（至少10x10英尺）',
			item2: '电源接入（50英尺内的标准插座）',
			item3: '客人的桌椅',
			item4: '如需要，提供天气防护（帐篷、凉亭等）',
		},
		section5: {
			title: '5. 食品安全与过敏',
			desc: '请在预约时告知我们任何食物过敏或饮食限制。虽然我们会采取预防措施，但由于铁板烧烹饪的性质，我们无法保证完全无过敏原的环境。',
		},
		section6: {
			title: '6. 责任',
			desc: 'Happy Hibachi 持有责任保险。但是，客户需对其客人和财产负责。我们不对客人行为或既有财产条件造成的事故承担责任。',
		},
		section7: {
			title: '7. 服务区域',
			intro: '我们目前服务：',
			california: '加利福尼亚（洛杉矶、圣地亚哥、旧金山及周边地区）',
			texas: '德克萨斯（休斯顿、达拉斯、奥斯汀、圣安东尼奥及周边地区）',
			florida: '佛罗里达（迈阿密、劳德代尔堡及周边地区）',
			travelFee: '标准服务区域外的地点可能收取交通费。',
		},
		section8: {
			title: '8. 条款变更',
			desc: '我们保留随时修改这些条款的权利。继续使用我们的服务即表示接受更新后的条款。',
		},
		section9: {
			title: '9. 联系方式',
			intro: '关于这些条款的问题：',
		},
	},
	status: {
		pending: '待确认',
		confirmed: '已确认',
		completed: '已完成',
		cancelled: '已取消',
	},
	timeSlot: {
		afternoon: '下午',
		evening: '傍晚',
		night: '晚间',
	},
	admin: {
		login: {
			title: '管理员登录',
			subtitle: '输入密码访问管理后台',
			password: '密码',
			loginButton: '登录',
			loggingIn: '登录中...',
			invalidPassword: '密码错误',
			loginFailed: '登录失败，请重试。',
			contactHelp: '联系获取访问权限',
		},
		dashboard: {
			title: '管理后台',
			logout: '退出登录',
		},
		stats: {
			totalBookings: '总预约数',
			pending: '待处理',
			confirmed: '已确认',
			completed: '已完成',
			cancelled: '已取消',
			totalGuests: '总客人数',
		},
		tabs: {
			all: '全部',
			pending: '待处理',
			confirmed: '已确认',
			completed: '已完成',
			cancelled: '已取消',
		},
		booking: {
			noBookings: '暂无预约',
			noBookingsHint: '客户提交表单后，预约将显示在这里',
			booking: '预约',
			estimate: '询价',
			guests: '位客人',
			contactInfo: '联系信息',
			eventDetails: '活动详情',
			date: '日期',
			time: '时间',
			region: '地区',
			notSpecified: '未指定',
			additionalNotes: '备注信息',
			updateStatus: '更新状态',
			emailCustomer: '发送邮件',
			callCustomer: '拨打电话',
		},
	},
};

export default zh;
